import * as Yup from "yup";

import {
  CabinContentsCoverage,
  CabinCoverage,
} from "Store/interfaces/products/coverage";

import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { CabinContentsSum } from "../../CabinContents/cabinContentsConstants";
import { CabinPriceFormValues } from "./cabinProductPriceInterfaces";

export const validationSchema = (): Yup.ObjectSchema<CabinPriceFormValues> => {
  const { getText } = TextManager;

  return Yup.object({
    deductible: Yup.string().required(
      getText("cabinform.validation.deductible"),
    ),
    coverage: Yup.mixed<CabinCoverage>().required(
      getText("cabinform.validation.coverage"),
    ),
    addContentsInsurance: Yup.mixed<BooleanFormType>().required(
      getText("cabinform.validation.addcontentsinsurance"),
    ),
    contentsDeductible: Yup.string().when("addContentsInsurance", {
      is: BooleanFormType.TRUE,
      then: (schema) =>
        schema.required(getText("cabinform.validation.contentsdeductible")),
    }),
    contentsInsuranceSum: Yup.number().when("addContentsInsurance", {
      is: BooleanFormType.TRUE,
      then: (schema) =>
        schema
          .required(
            getText("cabinform.validation.contentsinsurancesum_required"),
          )
          .max(
            CabinContentsSum.UPPER_LIMIT,
            ErrorPrefix.BREAKING +
              getText("cabinform.validation.contentsinsurancesum_toohigh"),
          )
          .min(
            CabinContentsSum.LOWER_LIMIT,
            getText("cabinform.validation.contentsinsurancesum_toolow"),
          ),
    }),
    contentsCoverage: Yup.mixed<CabinContentsCoverage>().when(
      "addContentsInsurance",
      {
        is: BooleanFormType.TRUE,
        then: (schema) =>
          schema.required(getText("cabinform.validation.contentscoverage")),
      },
    ),
    injuries: Yup.string().when("addContentsInsurance", {
      is: BooleanFormType.TRUE,
      then: (schema) =>
        schema
          .required(getText("cabinform.validation.injuries_required"))
          .notOneOf(
            [DamageRecentYears.TWO_OR_MORE],
            ErrorPrefix.BREAKING +
              getText("cabinform.validation.injuries_maxdamages"),
          ),
    }),
    injuryYear: Yup.string().when("injuries", {
      is: DamageRecentYears.ONE,
      then: (schema) =>
        schema.required(getText("cabinform.validation.injuryyear")),
    }),
  }).defined();
};
